<template>
  <main id="contents" class="main">
    <PpvConfirm></PpvConfirm>
    <PpvToast></PpvToast>
    <notice-popup/>
    <super-multi-section></super-multi-section>
  </main>
</template>

<script>
import NoticePopup from '@/components/common/NoticePopup'
import SuperMultiSection from '@/components/container/SuperMultiSection'
import { setDisableScrolling, scrollTop, titleTagNameChange } from '@/common/utils/common'
import { mapMutations } from 'vuex'
import { MENU, SET_CURRENT_MENU } from '@/common/resources/const'
import PpvConfirm from '@/components/movie/PpvConfirm'
import PpvToast from '@/components/movie/PpvToast'
export default {
  components: {
    SuperMultiSection,
    NoticePopup,
    PpvConfirm,
    PpvToast
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  created () {
    scrollTop()
    setDisableScrolling(false)
    this[SET_CURRENT_MENU](MENU.HOME)
    titleTagNameChange('Wavve(웨이브)')
  }
}
</script>
